<template>
<w-settings-detail :title="title" :menu="menu" @change="onChangeMenu">
  <w-settings-content-template slot="activeView">
    <w-saved-query-common-table slot="content" :target-data="targetData" :title="targetTitle"></w-saved-query-common-table>
  </w-settings-content-template>
</w-settings-detail>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import WSettingsDetail from '@/components/template/SettingsDetail';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import objtypeApi from '@/api/model/objtype';
import WSavedQueryCommonTable from './components/SavedQueryCommonTable';

const dbUserQuetyRsctypeIdMap = {
  ORACLE: 'OR_USER_QUERY',
  MSSQL: 'MS_USER_QUERY',
  TIBERO: 'TB_USER_QUERY',
  MYSQL: 'MY_USER_QUERY',
  DB2: 'DB2_USER_QUERY',
  CUBRID: 'CU_USER_QUERY',
  POSTGRESQL: 'PG_USER_QUERY',
  INFORMIX: 'IN_USER_QUERY',
  SYBASE: 'SY_USER_QUERY',
  SYBASEIQ: 'IQ_USER_QUERY',
  ALTIBASE: 'AT_USER_QUERY',
};
export default {
  name: 'WSavedQuery',
  components: {
    WSettingsDetail,
    WSettingsContentTemplate,
    WSavedQueryCommonTable,
  },
  props: {
    title: String,
  },
  data() {
    return {
      activeMenu: 'WOracleSavedQuery',
      targetData: {},
      targetTitle: '',
      menu: [],
    };
  },
  created() {
    const me = this;
    objtypeApi
      .getProviedObjtypeList('DBMS')
      .then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          const menu = [];
          forEach(response.data.data, (item) => {
            if (!isNil(dbUserQuetyRsctypeIdMap[item.objtypeId])) {
              menu.push({
                id: item.objtypeId,
                name: `${item.objtypeName} 사용자 쿼리`,
                active: false,
                targetData: {
                  rsctypeId: dbUserQuetyRsctypeIdMap[item.objtypeId],
                  managetypeId: 'DBMS',
                },
              });
            }
          });
          me.menu = menu;
          if (!isEmpty(menu)) {
            me.onChangeMenu(menu[0].id);
          }
        } else {
          me.menu = [];
        }
      })
      .catch(() => {
        me.menu = [];
      });
  },
  methods: {
    onChangeMenu(menu) {
      const findData = this.menu.find((item) => item.id === menu);
      this.activeMenu = menu;
      this.targetTitle = findData.name;
      this.targetData = findData.targetData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/database/SavedQuery/index.vue